import type { ReactNode } from 'react';

export const Label = ({ children }: { children: ReactNode }) => (
  <span className="mb-label block text-micro font-medium tracking-group text-faint">
    {children}
  </span>
);

export const Problem = ({ children }: { children?: string }) =>
  children ? <span className="mt-1 block text-meta text-danger">{children}</span> : null;

export const Hint = ({ children }: { children: ReactNode }) => (
  <span className="mt-1 block text-meta text-muted">{children}</span>
);
